import API_URL from 'src/api/apiConstants';
import { DATE_FORMAT, REPORT_FILTER_OPTIONS } from 'src/utils/constants';
import { getFormattedDate } from 'src/utils/getInitials';
import { reportFormConfig } from './reportFormModel';
import { sensorTransactionReportFormConfig } from '../sensorTransactions/sensorTransactionReportFormModel';
import { breakdownReportFormConfig } from '../breakdown/breakdownReportFormModel';
import { vehicleUtilizationReportFormConfig } from '../otherReports/vehicleUtilizationReportFormModel';
import { vehicleSummaryReportFormConfig } from '../otherReports/vehicleSummaryReportFormModel';

export const REPORTS = {
  vehicleSummary: 'vehicleSummaryReport',
  vehicleUtilization: 'vehicleUtilizationReport',
  sensorTransaction: 'sensorTransactionReport',
  vehicleGroupWise: 'vehicleGroupWiseReport',
  groupWiseComparison: 'groupWiseComparisonReport',
  breakdown: 'breakdownReport',
  milage: 'mileageReport',
  vehicleRecords: 'vehicleRecordsReport'
};

// eslint-disable-next-line import/prefer-default-export
export const getReportConfig = (reportName) => {
  const defaultConfig = {
    filterOptions: {},
    downloadUrl: API_URL[reportName],
    dateConfig: { onlyDate: false, dateFormat: null },
    formConfig: reportFormConfig
  };
  let reportConfig = { ...defaultConfig };
  switch (reportName) {
    case REPORTS.vehicleSummary:
      reportConfig = {
        ...defaultConfig,
        filterOptions: { wailonVehicle: true },
        dateConfig: { onlyDate: true },
        formConfig: vehicleSummaryReportFormConfig
      };
      break;
    case REPORTS.vehicleUtilization:
      reportConfig = {
        ...defaultConfig,
        filterOptions: { assetType: true },
        dateConfig: { onlyDate: true, views: ['month', 'year'], openTo: 'month' },
        formConfig: vehicleUtilizationReportFormConfig
      };
      break;
    case REPORTS.sensorTransaction:
      reportConfig = {
        ...defaultConfig,
        filterOptions: { vehicle: true },
        dateConfig: { dateFormat: DATE_FORMAT.timeStamp },
        formConfig: sensorTransactionReportFormConfig
      };
      break;
    case REPORTS.vehicleGroupWise:
      reportConfig = {
        ...defaultConfig,
        filterOptions: { assetType: true },
        dateConfig: { dateFormat: DATE_FORMAT.timeStamp },
      };
      break;
    case REPORTS.groupWiseComparison:
      reportConfig = {
        ...defaultConfig,
        formConfig: vehicleUtilizationReportFormConfig
      };
      break;
    case REPORTS.breakdown:
      reportConfig = {
        ...defaultConfig,
        filterOptions: { vehicle: true, assetType: true },
        dateConfig: { dateFormat: DATE_FORMAT.timeStamp },
        formConfig: breakdownReportFormConfig
      };
      break;
    case REPORTS.milage:
      reportConfig = {
        ...defaultConfig,
        filterOptions: { ...REPORT_FILTER_OPTIONS, dispenser: false },
      };
      break;
    case REPORTS.vehicleRecords:
      reportConfig = {
        ...defaultConfig,
        dateConfig: { onlyDate: true },
        formConfig: breakdownReportFormConfig
      };
      break;
    default:
      break;
  }
  return reportConfig;
};

export const getFormattedReportURL = (url, payload, isExport) => {
  const {
    title, data, startTime, endTime, pageNo, limit
  } = payload;
  let formPayload = { ...data };
  let reportUrl = isExport ? url : `${url}&page=${pageNo}&page_size=${limit}`;
  if (title === REPORTS.vehicleSummary) {
    reportUrl = url.replace('{vehicleId}', data.vehicle_id);
    formPayload = {
      [startTime.name]: getFormattedDate(data[startTime.name], 'DD-MM-YYYY'),
      [endTime.name]: getFormattedDate(data[endTime.name], 'DD-MM-YYYY')
    };
  } else if (title === REPORTS.vehicleUtilization) {
    const formattedDate = getFormattedDate(formPayload[startTime.name], 'MMM,MM,YYYY');
    const dateArray = formattedDate.split(',');
    formPayload = {
      asset_type: data.asset_type, month: dateArray[1], year: dateArray[2], month_text: dateArray[0]
    };
    delete formPayload[startTime.name];
  } else if (title === REPORTS.groupWiseComparison) {
    formPayload = { date: getFormattedDate(formPayload[startTime.name], 'DD-MM-YYYY:HH-mm') };
    delete formPayload[startTime.name];
  }
  const keyList = Object.keys(formPayload);
  let queryParams = '';
  keyList.forEach((key) => {
    if (formPayload[key] && formPayload[key] !== 'all') {
      queryParams += `&${key}=${formPayload[key]}`;
    }
  });
  const apiURL = reportUrl + queryParams;
  return apiURL;
};
